/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Principle_1_TitleInputs */

const en_about_principle_1_title = /** @type {(inputs: About_Principle_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curiosity before a solution.`)
};

const lv_about_principle_1_title = /** @type {(inputs: About_Principle_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziņkāre pirms risinājuma.`)
};

/**
* | output |
* | --- |
* | "Curiosity before a solution." |
*
* @param {About_Principle_1_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_principle_1_title = /** @type {((inputs?: About_Principle_1_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Principle_1_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_principle_1_title(inputs)
	return en_about_principle_1_title(inputs)
});